/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, duration: NonNullable<unknown> }} Audio_Description_Export_Event_Time_Exceeds_DurationInputs */

const en_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} has a start or end time that exceeds the duration (${i?.duration}s) of the source media file.`)
};

const fr_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evenement ${i?.index} a un debut ou une fin qui depasse la duree (${i?.duration}s) du fichier media source.`)
};

const de_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} hat eine Start- oder Endzeit, die die Dauer (${i?.duration}s) der Quellmediendatei überschreitet.`)
};

const it_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} ha un orario di inizio o di fine che supera la durata (${i?.duration}s) del file multimediale di origine.`)
};

const ru_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} имеет время начала или окончания, превышающее длительность (${i?.duration}s) исходного медиафайла.`)
};

const es_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} tiene una hora de inicio o finalización que excede la duración (${i?.duration}s) del archivo multimedia de origen.`)
};

const zh_cn2_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 的开始时间或结束时间超过了源媒体文件的持续时间 (${i?.duration}s)。`)
};

const ja_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} の開始時刻または終了時刻が、ソース メディア ファイルの継続時間 (${i?.duration} 秒) を超えています。`)
};

const hi_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`घटना ${i?.index} का प्रारंभ या समाप्ति समय स्रोत मीडिया फ़ाइल की अवधि (${i?.duration}s) से अधिक है।`)
};

const pt_pt2_audio_description_export_event_time_exceeds_duration = /** @type {(inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} tem um horário de início ou término que excede a duração (${i?.duration}s) do arquivo de mídia de origem.`)
};

/**
* | output |
* | --- |
* | "Event {index} has a start or end time that exceeds the duration ({duration}s) of the source media file." |
*
* @param {Audio_Description_Export_Event_Time_Exceeds_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_event_time_exceeds_duration = /** @type {((inputs: Audio_Description_Export_Event_Time_Exceeds_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Event_Time_Exceeds_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "de") return de_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "it") return it_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "ru") return ru_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "es") return es_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "ja") return ja_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "hi") return hi_audio_description_export_event_time_exceeds_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_event_time_exceeds_duration(inputs)
	return en_audio_description_export_event_time_exceeds_duration(inputs)
});